import { LeaseModal } from "@/admin/metal/machine/LeaseModal.tsx";
import type { AdminMachineWithOs } from "@/admin/metal/machine/machinesWithOs.ts";
import { EditableButton } from "@/components/forms/EditableButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { MetalStatusBadge } from "@/modules/metal/status/MetalStatus.tsx";

export function StatusEditButton({ item }: { item: AdminMachineWithOs }) {
    const canEdit = item.status !== "deleted";
    const badge = <MetalStatusBadge value={item.status} />;
    return canEdit ? (
        <WModal button={<EditableButton action={undefined}>{badge}</EditableButton>}>
            <LeaseModal machine={item} />
        </WModal>
    ) : (
        badge
    );
}
